import classes from "./DiplomatDetail.module.css";
import {useState} from "react";
import { assetsBaseUrl } from "../../../routes";

const Diplomat_Detail = (props) =>{
    //console.log(props);
    const [logo, setLogo] = useState(`${assetsBaseUrl}${props.data[0].path}`||"")
    const [room, setRoom] = useState(props.data[0].room||"")
    return <>
        <img src={logo}/>
        <label>{room}</label>
    </>
}
export default Diplomat_Detail;
